import PropTypes from 'prop-types'
import {Map} from 'immutable'

import AccountSettingsRow from './AccountSettingsRow'

import {isFuneralHome} from '../../../../../pro/src/lib/firmTools'

const SubscriptionInformation = ({accountSetting, firm}) => {
  if (accountSetting.get('subscription-text')) {
    const url = () => {
      if (accountSetting.get('show-subscription-button')) {
        if (isFuneralHome(firm))
          return '/cm/account-settings/preneed-payment-form'

        return '/cm/account-settings/payment-form'
      } else if (accountSetting.get('subscription-payment-gateway') === 'stripe' && accountSetting.get('is-consumer-with-purchased-subscription')) {
        return 'cm/account-settings/subscription-and-billing'
      }
    }

    const buttonText = accountSetting.get('show-subscription-button') ? 'Upgrade to Premium' : 'Manage subscription'

    return (
      <AccountSettingsRow
        title='Subscription'
        bodyText={accountSetting.get('subscription-text')}
        url={url()}
        buttonText={buttonText}
      />
    )
  } else {
    return null
  }
}

SubscriptionInformation.propTypes = {
  accountSetting: PropTypes.instanceOf(Map),
  firm: PropTypes.instanceOf(Map)
}

export default SubscriptionInformation
